const config = {
    AUTH_ADDRESS: 'https://auth.dblog.org/dashboard',
    API_ADDR: 'https://api.dblog.org',
    MAIN_PAGE_ADDR: 'https://dblog.org',
    DOMAINS: [
        'dblog.org',
        'engrave.site',
        'engrave.website'
    ],
    SERVER_IP: '167.71.119.171',
    LANG: 'en',
    BOTS: ['tipu', 'hivebuzz', 'text2speech', 'poshbot', 'pixresteemer', 'beerlover', 'misterengagement']
}

export default config;
